import { theme } from '@features/lci-report/domain/theme';
import { PositionProps, ShapeProps } from '@features/powerpoint';

const axisLine = (
  position: PositionProps,
  dashType?: Required<ShapeProps['options']>['line']['dashType']
): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.white,
      dashType,
    },
    ...position,
  },
});

export const xAxis = axisLine({ h: 0.06, w: 11.71, x: 0.85, y: 6.4 });
export const yAxis = axisLine({ h: 4.02, w: 0, x: 0.85, y: 2.38 });
export const divider = axisLine({ h: 4.02, w: 0, x: 3.82, y: 2.41 }, 'dash');
